/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * WordPress dependencies
 */
import {__} from '@wordpress/i18n';
import {
    useBlockProps, InspectorControls,
} from '@wordpress/block-editor';

import {dispatch} from '@wordpress/data';


import {
    PanelBody,
    TextControl,
    Notice,
    FocusableIframe, RangeControl, SelectControl,
} from '@wordpress/components';
import languages from "../../assets/languages";



function Edit({attributes, setAttributes,...props}) {
    const {
        key,
        address,
        zoom,
        height,
        language,
    } = attributes;

    const DEFAULT_LANGUAGE = 'en';

    const language_par = language ? language : DEFAULT_LANGUAGE;
    const blockProps = useBlockProps();

    const src = `https://www.google.com/maps/embed/v1/place?key=${key}&q=${address}&zoom=${zoom}&language=${language_par}`;

    const selectedBlock = () => {
        dispatch('core/block-editor').selectBlock(props.clientId);
    }

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('General')} className="buba-map__settings">
                    <Notice status="success"
                            isDismissible={false}
                    >
                        {__('This block uses Google Maps API key to display the map.')}
                    </Notice>
                    <TextControl
                        label="Google Maps Api Key"
                        value={key}
                        onChange={(value) => {
                            setAttributes({key: value})
                        }}
                    />
                    <TextControl
                        label="Address"
                        value={decodeURI(address)}
                        onChange={(value) => {
                            setAttributes({address: encodeURI(value)})
                        }}
                    />
                    <RangeControl
                        value={height}
                        label={__('Height (px)')}
                        min={0}
                        max={1000}
                        allowReset
                        onChange={(height) => {
                            setAttributes({
                                height
                            })
                        }}
                    />
                    <RangeControl
                        value={zoom}
                        label={__('Zoom')}
                        min={1}
                        max={22}
                        allowReset
                        onChange={(zoom) => {
                            setAttributes({
                                zoom
                            })
                        }}
                    />
                    <SelectControl
                        label={__('Language')}
                        value={language}
                        onChange={(language) => {
                            setAttributes({
                                language
                            })
                        }}
                        options={languages}
                    />
                </PanelBody>
            </InspectorControls>
            <div
                {...blockProps}
                className={classnames('buba-map-wrap', blockProps.className, {},)}
                style={{
                    ...blockProps.style,
                }}
            >
                <FocusableIframe
                    style={{
                        height: height ? height +'px':undefined,
                    }}
                    className="buba-map__iframe"
                    src={src}
                    onFocus={selectedBlock}
                />

            </div>
        </>
    )
}

export default Edit;